import { defineMessages } from 'react-intl';

export const XFlowFlagMessages = defineMessages({
  errorDescription: {
    defaultMessage: 'Something went wrong. Please try again.',
    description: 'error description when fetching contents of iframe',
    id: 'uchi.xflow.generic.iframe.error-flag.description',
  },
  errorTitle: {
    defaultMessage: 'Well, this is awkward...',
    description: 'error title when fetching contents of iframe',
    id: 'uchi.xflow.generic.iframe.error-flag.title',
  },
  retryButtonText: {
    defaultMessage: 'Retry',
    description: 'reinitiate fetching the contents of the iframe',
    id: 'uchi.xflow.generic.iframe.error-flag.retry-button-text',
  },
});
